import api from "../../services/api";

const request = async (url, params) => {
  const { data } = await api.request({
    url,
    method: "GET",
    params,
  });

  return data;
};

const useDashboard = () => {
  const find = async params => request("/dashboard", params);

  const getSummary = async params => request("/dashboard/summary", params);

  const getTicketsStatus = async params =>
    request("/dashboard/tickets/status", params);

  const getTicketsQueues = async params =>
    request("/dashboard/tickets/queues", params);

  const getAttendantsPerformance = async params =>
    request("/dashboard/attendants/performance", params);

  const getContactsStates = async params =>
    request("/dashboard/contacts/states", params);

  const getContactsTags = async params =>
    request("/dashboard/contacts/tags", params);

  const getContactsWallets = async params =>
    request("/dashboard/contacts/wallets", params);

  const getContactsReactivation = async params =>
    request("/dashboard/contacts/reactivation", params);

  const getContactsSegmentation = async params =>
    request("/dashboard/contacts/segmentation", params);

  const getMessagesOverview = async params =>
    request("/dashboard/messages/overview", params);

  const getMessagesMediaTypes = async params =>
    request("/dashboard/messages/media-types", params);

  const getTicketsBotUsage = async params =>
    request("/dashboard/tickets/bot-usage", params);

  const getTicketsOutOfHours = async params =>
    request("/dashboard/tickets/out-of-hours", params);

  const getReport = async params =>
    request("/ticketreport/reports", params);

  return {
    find,
    getSummary,
    getTicketsStatus,
    getTicketsQueues,
    getAttendantsPerformance,
    getContactsStates,
    getContactsTags,
    getContactsWallets,
    getContactsReactivation,
    getContactsSegmentation,
    getMessagesOverview,
    getMessagesMediaTypes,
    getTicketsBotUsage,
    getTicketsOutOfHours,
    getReport,
  };
};

export default useDashboard;
